// Helper

const TypeHelper = {
  isInstanceOf: <T>(object: any): object is T => object !== undefined,
};

// Export

export default TypeHelper;
